<template>
  <div name="hrms14x-popup-status" id="hrms14x-popup-status" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header header-popup">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">{{ labels['HRMS14XC2']['10'] }}</h4>
        </div>

        <div class="modal-body detail detail-responsive">
          <div class="detail detail-responsive">
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-2 control-label">{{ labels['HRMS14XC2']['20'] }}</label>
                <div class="col-md-4">
                  <div class="form-control readonly-field-color">{{ indexSelected.codapp }} - {{ indexSelected.desc_codapp }}</div>
                </div>
                <label class="col-md-2 control-label">{{ labels['HRMS14XC2']['30'] }}</label>
                <div class="col-md-4">
                  <div class="form-control readonly-field-color">{{ indexSelected.desc_codempid }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-2 control-label">{{ labels['HRMS14XC2']['40'] }}</label>
                <div class="col-md-4">
                  <div class="form-control readonly-field-color">{{ indexSelected.routeno }}</div>
                </div>
                <label class="col-md-2 control-label">{{ labels['HRMS14XC2']['50'] }}</label>
                <div class="col-md-4">
                  <div class="form-control readonly-field-color">{{ setDateTimeOutput(indexSelected.dteinput) }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-2 control-label">{{ labels['HRMS14XC2']['60'] }}</label>
                <div class="col-md-4">
                  <div class="form-control readonly-field-color">{{ indexSelected.desc_staappr }}</div>
                </div>
              </div>
            </form>
	          <hrms-table v-if="!popupStatusEditDisp" 
	          						:columns="columns" 
	          						:data="data" 
	          						:editEvent="editEvent" 
                        :popupSelected="popupSelected"
	          						id="settime" 
	          						class="animated fadeIn"/>    


	          <template v-if="popupStatusEditDisp">
	          	<div class="hrms14x-popup-edit-box" ></div>
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-2 control-label">{{ labels['HRMS14XC3']['70'] }}</label>
                  <div class="col-md-4">
                    <div class="form-control readonly-field-color">{{ popupSelected.seqno }}</div>
                  </div>
                  <label class="col-md-2 control-label">{{ labels['HRMS14XC3']['80'] }}</label>
                  <div class="col-md-4">
                    <div class="form-control readonly-field-color">{{ popupSelected.typeapp }}</div>
                  </div>
                </div>
              </form>
              <hrms-table :columns="columnsStatusEdit" 
                          :data="dataStatusEdit" 
                          :addInlineEventBool="true"
                          :editInlineEventBool="true"
                          :deleteInlineEventBool="true"
                          :saveInlineEvent="callSave"
                          :popupSelected="popupSelected"
                          id="settime"  
                          class="animated fadeIn"
                          :backEvent="backEvent" />
	          </template>
          </div>            
        </div>        
      </div>
    </div>
  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hrms14x-popup-status',
  props: [ 'labels',
    'data',
    'columns',
    'indexSelected',
    'receivedHrms14xStatusEditPopup',
    'dataStatusEdit',
    'columnsStatusEdit',
    'labelsButton',
    'setPopupSelected',
    'popupSelected',
    'popupStatusEditDisp',
    'setPopupStatusEditDisp',
    'postPopupStatusEditSave',
    'searchParams'
  ],
  methods: {
    setDateTimeOutput (date) {
      return assetsUtils.getDateTimeOutput(date)
    },
    backEvent () {
      this.setPopupStatusEditDisp(false)
    },
    editEvent (dataRow) {
      if (dataRow.seqno) {
        this.setPopupStatusEditDisp(true)
        this.setPopupSelected(dataRow)
        let popupParams = Object.assign(this.indexSelected, dataRow)
        popupParams.approvno = dataRow.seqno
        this.receivedHrms14xStatusEditPopup(popupParams)
      }
    },
    callSave (dataRowsHasFlg) {
      this.$validator.validateAll().then(result => {
        if (result) {
          let param = {
            codapp: this.indexSelected.codapp,
            codempid_query: this.indexSelected.codempid,
            dtereq: this.indexSelected.dtereq,
            numseq: this.indexSelected.numseq,
            approvno: this.indexSelected.approvno,
            seqno: this.popupSelected.seqno
          }
          for (var i = 0; i < dataRowsHasFlg.length; i++) {
            dataRowsHasFlg[i] = Object.assign(dataRowsHasFlg[i], param)
          }
          this.postPopupStatusEditSave({ dataRowsHasFlg: dataRowsHasFlg, popupParams: this.searchParams })
        }
      })
    }
  }
}
</script>

<style lang="scss">
	#settime {
	  animation-duration: 1s;
	}
	.hrms14x-popup-edit-box {
		border-top: 1px solid #EDEDED;
		padding: 5px;
		margin: 5px 0 0 0;
	}
	
</style>


// WEBPACK FOOTER //
// popupStatus.vue?2fb767c0